/**
 * WO-INV1 — invoice branding API client (authed, owner-gated).
 *
 * Routes (beam-backend/src/api/accountRouter.ts):
 *   GET    /api/account/branding        → BrandingResponse
 *   PATCH  /api/account/branding        → BrandingResponse  (partial update)
 *   POST   /api/account/branding/logo   → BrandingResponse  (base64-in-JSON upload)
 *   DELETE /api/account/branding/logo   → BrandingResponse
 *
 * All shapes from @beam/api-types — never re-declared here. No SmartBox import (invariant 1).
 */
import {
  BrandingResponse,
  type BrandingResponse as BrandingResponseType,
  type UpdateBrandingRequest,
  type UploadLogoRequest,
} from '@beam/api-types';
import { get, patch, post, del } from './client';

export async function getBranding(): Promise<BrandingResponseType> {
  return BrandingResponse.parse(await get<unknown>('/api/account/branding'));
}

export async function updateBranding(patchBody: UpdateBrandingRequest): Promise<BrandingResponseType> {
  return BrandingResponse.parse(await patch<unknown>('/api/account/branding', patchBody));
}

export async function uploadLogo(body: UploadLogoRequest): Promise<BrandingResponseType> {
  return BrandingResponse.parse(await post<unknown>('/api/account/branding/logo', body));
}

export async function deleteLogo(): Promise<BrandingResponseType> {
  return BrandingResponse.parse(await del<unknown>('/api/account/branding/logo'));
}
